import colors from "styles/colors";
import styled from "styled-components";
import VerificationBg from "assets/png/verification-llustration.png";
import { device } from "styles";

const ForgotPasswordText = styled.div`
  color: #006355;
  text-align: right;
  margin-bottom: 40px;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const AccountSwitch = styled.div`
  font-size: 14px;
  text-align: left;
  margin: 2rem 0;
  font-weight: 400;
  color: #192850;

  span {
    color: ${colors.pri};
    padding-left: 6px;

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }

  @media ${device.mobile_} {
    margin: 1rem 0;
  }
`;

const AuthButtonContainer = styled.div`
  button {
    margin: 0;
    width: 100%;
  }
  margin-bottom: 1.5rem;
`;

const VerficationContainer = styled.div`
  background: url(${VerificationBg});
  height: 100%;
  background-repeat: no-repeat;
  background-position: 0 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: auto;

  span {
    color: ${colors.pri};
    text-decoration: underline;
    cursor: pointer;
  }

  h4 {
    font-size: 18px;
  }

  p {
    color: #16243a;
    font-size: 14px;
  }
`;

const VerificationElements = styled.div`
  max-width: 600px;
`;

const ForgotPasswordContainer = styled.div`
  p {
    font-size: 14px;
    line-height: 20px;
    color: rgba(22, 36, 58, 0.8);
  }

  button {
    margin-top: 20px;
  }

  form {
    margin-top: 40px;
  }
`;

const ResetPasswordContainer = styled.div`
  h3 {
    color: rgba(22, 36, 58, 0.8);
    font-size: 17px;
  }

  form {
    margin-top: 40px;
  }

  button {
    margin-top: 25px;
  }
`;

const RememberMeContainer = styled.div`
  display: flex;
  font-size: 14px;
  color: #192850;
  align-items: center;
  margin-bottom: 20px;

  input {
    margin-right: 8px;
  }
`;

const BusinessSignupOptions = styled.div`
  margin: 25px 0;
  padding: 0;
  list-style-type: none;
  width: 100%;
  li {
    flex-grow: 1;

    .radio-label {
      cursor: pointer;
      font-weight: 600;
      padding: 12px 20px 0px 30px;
      position: relative;
      transition: 0.3s ease all;
      color: #5c696e;
      font-weight: 300;
      display: block;
      font-size: 14px;
    }

    .radio-label:before {
      background: #fff;
      border-radius: 50%;
      content: "";
      height: 13px;
      left: 0px;
      position: absolute;
      top: calc(50% - 1px);
      transition: 0.3s ease background-color;
      width: 13px;
      border: 2px solid rgba(92, 105, 110, 0.3);
    }
    .radio-label span {
      -webkit-user-select: none;
      -moz-user-select: none;
      user-select: none;
    }
    .radio-btn {
      position: absolute;
      visibility: hidden;
    }
  }
  .radio-btn:checked + .radio-label:before {
    background-color: rgba (11, 46, 40, 0.5);
    border: 3px solid #006355;
    background: ".";
    background-repeat: no-repeat;
    background-position: center;
    background-size: 15px;
  }
  .radio-btn:checked + .radio-label:after {
    background: #006355;
    opacity: 0.5;
    border-radius: 50%;
    content: "";
    height: 3px;
    left: 6px;
    position: absolute;
    top: calc(50% - -5px);
    transition: 0.3s ease background-color;
    width: 3px;
    border: 2px solid rgba(92, 105, 110, 0.3);
  }
`;

export {
  ForgotPasswordText,
  AccountSwitch,
  AuthButtonContainer,
  VerficationContainer,
  VerificationElements,
  ForgotPasswordContainer,
  ResetPasswordContainer,
  RememberMeContainer,
  BusinessSignupOptions
};
